var composeDatePickerColorKeys = [
  "containerColor",
  "titleContentColor",
  "headlineContentColor",
  "weekdayContentColor",
  "subheadContentColor",
  "navigationContentColor",
  "yearContentColor",
  "disabledYearContentColor",
  "currentYearContentColor",
  "selectedYearContentColor",
  "disabledSelectedYearContentColor",
  "selectedYearContainerColor",
  "disabledSelectedYearContainerColor",
  "dayContentColor",
  "disabledDayContentColor",
  "selectedDayContentColor",
  "disabledSelectedDayContentColor",
  "selectedDayContainerColor",
  "disabledSelectedDayContainerColor",
  "todayContentColor",
  "todayDateBorderColor",
  "dayInSelectionRangeContentColor",
  "dayInSelectionRangeContainerColor",
  "dividerColor"
];
var composeTimePickerColorKeys = [
  "containerColor",
  "clockDialColor",
  "clockDialSelectedContentColor",
  "clockDialUnselectedContentColor",
  "selectorColor",
  "periodSelectorBorderColor",
  "periodSelectorSelectedContainerColor",
  "periodSelectorUnselectedContainerColor",
  "periodSelectorSelectedContentColor",
  "periodSelectorUnselectedContentColor",
  "timeSelectorSelectedContainerColor",
  "timeSelectorUnselectedContainerColor",
  "timeSelectorSelectedContentColor",
  "timeSelectorUnselectedContentColor"
];
export {
  composeDatePickerColorKeys,
  composeTimePickerColorKeys
};
//# sourceMappingURL=composeTypes.js.map
